import e from"./StateResults.vue_vue&type=script&lang.js";import{render as t}from"./StateResults.vue_vue&type=template&id=5992f3d5&lang.js";e.render=t,e.__file="src/components/StateResults.vue";export default e;
//# sourceMappingURL=StateResults.vue.js.map
